import {
  Modal,
  Form,
  Input,
  Button,
  Col,
  Row,
  notification,
  DatePicker,
} from "antd";
import locale from "antd/es/date-picker/locale/es_ES";
import "dayjs/locale/es-mx";
import store from "../../../../../controllers/store";
import { useSelector } from "react-redux";
import { create } from "../../../../../controllers/store/actions/searchers/create-searcher-action";
import SelectCities from "../../Elements/Select-Cities";
import SelectKnowledgeArea from "../../Elements/Select-Knowledge-Area";
import SelectKnowledgeSpecialty from "../../Elements/Select-Knowledge-Specialty";
import SelectKnowledgeGran from "../../Elements/Select-Knowledge-Gran";
import TextArea from "antd/es/input/TextArea";
import SelectRecognition from "../../Elements/Select-Recognize";
import { Actor } from "../../../..";
import SelectUniversity from "../../Elements/Select-University";
import { MaskedInput } from "antd-mask-input";
import SelectEntityDependency from "../../Elements/Select-Entity-Dependency";
import SelectProducts from "../../Elements/Select-Product-";

interface Props {
  loading?: boolean;
  visible: boolean;
  onCreated: () => void;
  onCancel: () => void;
}

const dispatch = store.dispatch;
const NewSearcherModal = (Props: Props) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const createdSearcher = useSelector((state: any) => state.createdSearcher);
  const actorTypesState = useSelector((state: any) => state.actorTypes);
  return (
    <Modal
      width={800}
      visible={Props.visible}
      title={"Investigador"}
      okText={"Agregar"}
      cancelText="Cancelar"
      footer={null}
      onCancel={Props.onCancel}
    >
      <>
        {contextHolder}
        <Form
          form={form}
          layout="vertical"
          onFinish={async (formData: any) => {
            form.validateFields().then(async (values: any) => {
              await dispatch(
                create({
                  contact_email: values.contact_email,
                  contact_name: values.contact_name,
                  city: values?.city?.value || "",
                  description: values.description,
                  recognized_min: values.recognized_min.value,
                  source: values.source,
                  phone: values.phone,
                  features: values.features,
                  update_date: new Date(values.update_date).toISOString(),
                  issue_date: new Date(values.issue_date).toISOString(),
                  current_date: new Date(values.current_date).toISOString(),
                  inst_filia: values.inst_filia || "",
                  enlace_cvlac: values.enlace_cvlac,
                  id_institucion: values.id_institucion || "",
                  nme_municipio_res_pr: values.city.label,
                  nme_clasificacion_pr: values.nme_clasificacion_pr,
                  nme_niv_form_pr: values.nme_niv_form_pr,
                  nme_gran_area_pr: values.nme_gran_area_pr.value,
                  nme_area_pr: values.nme_area_pr.value,
                  nme_esp_area_pr: values.nme_esp_area_pr.value,
                  nombre: values.nombre,
                  id_persona_pr: "",
                  universities: values.universities?.map((e: any) => ({
                    universities_id: e.value,
                  })),
                  products: values.products?.map((e: any) => ({
                    products_id: e.value,
                  })),
                  actor_type: actorTypesState.list?.find(
                    (c: any) => c.collection_name === Actor.ProminentResearcher
                  ).id,
                  entity: values.entity?.map((e: any) => ({
                    entities_id: e.value,
                  })),
                })
              );

              form.resetFields();
              Props.onCreated();
            });
          }}
          name="newSearcher"
        >
          <Row gutter={[8, 8]} style={{ width: "100%", marginTop: 30 }}>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Nombre completo"
                name="nombre"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el nombre completo",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Email de contacto"
                name="contact_email"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el email de contacto",
                  },
                  {
                    type: "email",
                    message: "Por favor ingrese un email válido",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Télefono"
                name="phone"
                rules={[{ type: "string", required: true }]}
              >
                <MaskedInput mask={"+57(000)000-0000"} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="Ciudad"
                name="city"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectCities
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("city", selected);
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={4}>
              <Form.Item
                label="Clasificación"
                name="nme_clasificacion_pr"
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={20}>
              <Form.Item
                label="Nivel de formación"
                name="nme_niv_form_pr"
                rules={[
                  { type: "string" },
                  {
                    required: true,
                    message: "Por favor ingrese el nivel de formación",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Area general"
                name="nme_area_pr"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeArea
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  size="large"
                  defaultValue="Área general"
                  onChange={(selected: any) => {
                    form.setFieldValue("nme_area_pr", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Área específica"
                name="nme_esp_area_pr"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeSpecialty
                  onClear={() => {}}
                  size="large"
                  defaultValue="Área específica"
                  onChange={(selected: any) => {
                    form.setFieldValue("nme_area_esp_pr", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Gran área del conocimiento"
                name="nme_gran_area_pr"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeGran
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  size="large"
                  defaultValue="Gran Área de conocimiento"
                  onChange={(selected: any) => {
                    form.setFieldValue("nme_gran_area_pr", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Institución"
                name="universities"
                rules={[{ type: "array" }]}
              >
                <SelectUniversity
                  onClear={() => {}}
                  mode={"multiple"}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("universities", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Productos"
                name="products"
                rules={[{ type: "array" }]}
              >
                <SelectProducts
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  mode={"multiple"}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("products", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Empresa"
                name="entity"
                rules={[{ type: "array" }]}
              >
                <SelectEntityDependency
                  mode={"multiple"}
                  onClear={() => {}}
                  filterActor={Actor.Company}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(selected: any) => {
                    console.log("selected", selected);
                    form.setFieldValue("entity", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="Reconocimiento MinCiencia"
                name="recognized_min"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectRecognition
                  onClear={() => {}}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("recognized_min", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Fuente"
                name="source"
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Características"
                name="features"
                rules={[{ type: "string" }]}
              >
                <TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Fecha de expedición"
                name="issue_date"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "Ingrese una fecha valida",
                  },
                ]}
              >
                <DatePicker
                  placeholder="Fecha de expedición"
                  format={"YYYY-MM-DD"}
                  onChange={(date, dateString) =>
                    form.setFieldValue("issue_date", date)
                  }
                  style={{ width: "100%" }}
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Vigencia"
                name="current_date"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "Ingrese una fecha valida",
                  },
                ]}
              >
                <DatePicker
                  format={"YYYY-MM-DD"}
                  onChange={(date, dateString) =>
                    form.setFieldValue("issue_date", date)
                  }
                  style={{ width: "100%" }}
                  size="large"
                  locale={locale}
                  placeholder="Vigencia"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Última actualización"
                name="update_date"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "Ingrese una fecha valida",
                  },
                ]}
              >
                <DatePicker
                  format={"YYYY-MM-DD"}
                  onChange={(date, dateString) =>
                    form.setFieldValue("issue_date", date)
                  }
                  style={{ width: "100%" }}
                  size="large"
                  locale={locale}
                  placeholder="Última actualización"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Enlace a cvlac"
                name="enlace_cvlac"
                rules={[{ type: "url" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item wrapperCol={{ span: 24 }}>
            <Button
              loading={createdSearcher?.isLoading}
              type="primary"
              size={"large"}
              block
              htmlType="submit"
            >
              Agregar investigador
            </Button>
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
};

export default NewSearcherModal;
